import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { plotList } from "@/mocks/plot";

export default function PlotFeature() {
  const featured = plotList[0];
  const rest = plotList.slice(1, 4);

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          eyebrow="STORY"
          title="剧情精选"
          description="从蜜桃园的盛夏初见，到多年后的重逢与和解，跟随章节节奏走进这段关于成长与等待的故事。"
          action={
            <Link
              to="/plot"
              className="flex items-center gap-1 whitespace-nowrap rounded-md border border-primary-300 px-4 py-2 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-50"
            >
              完整剧情
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          }
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-5">
          <Link
            to={`/detail/${featured.id}`}
            className="group relative col-span-1 overflow-hidden rounded-lg lg:col-span-3"
          >
            <div className="relative h-72 w-full md:h-96">
              <img
                src={featured.image}
                alt={featured.title}
                title={`${featured.chapter} ${featured.title} 剧情介绍`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/25 to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
                <span className="mb-2 inline-block rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
                  {featured.chapter}
                </span>
                <h3 className="mb-2 font-heading text-xl font-bold text-background-50 md:text-2xl">{featured.title}</h3>
                <p className="line-clamp-2 max-w-xl text-sm leading-relaxed text-background-100/90">{featured.summary}</p>
                <span className="mt-4 flex items-center gap-1 text-sm font-medium text-primary-200">
                  阅读本章
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center transition-transform group-hover:translate-x-1"></i>
                </span>
              </div>
            </div>
          </Link>

          <div className="col-span-1 flex flex-col gap-3 lg:col-span-2">
            {rest.map((item) => (
              <Link
                key={item.id}
                to={`/detail/${item.id}`}
                className="group flex flex-1 gap-4 overflow-hidden rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
              >
                <span className="h-24 w-28 shrink-0 overflow-hidden rounded-md bg-background-100">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </span>
                <span className="flex min-w-0 flex-1 flex-col">
                  <span className="text-xs font-medium text-primary-700">{item.chapter}</span>
                  <span className="mt-1 line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
                    {item.title}
                  </span>
                  <span className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{item.summary}</span>
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}